<template>
    <div v-show="ready">
        <img
            v-for="(frame,i) in frames"
            v-show="i === current"
            :src="frame"
            class="mw-100"
            role="presentation"
            @load="handleFrameLoaded(i)"
        >
    </div>
</template>

<script>
    export default {
        props: {
            frames: Array,
            speed: {
                type: Number, // in ms
                default: 500
            }
        },
        data() {
            return {
                loaded: this.frames.map(()=>false),
                current: 0
            }
        },
        computed: {
            ready() {
                return this.loaded.every(isLoaded => isLoaded);
            }
        },
        methods: {
            handleFrameLoaded(i) {
                this.$set(this.loaded, i, true);
                if(this.ready) {
                    setInterval(this.animate, this.speed);
                }
            },
            animate() {
                this.current++;
                this.current %= this.frames.length;
            }
        }
    }
</script>